// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aab6d6ec","663":"795e8750"}[chunkId] + ".chunk.js";
};